/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { GetDeviceScreenWidth } from '../../../utils';

export const withHooksHOC = (Component: any) => {
  return (props: any) => {
    const screenWidth = GetDeviceScreenWidth();

    return <Component isMobile={screenWidth <= 559} {...props} />;
  };
};
